import { render, staticRenderFns } from "./ProjectsPanelAddProjectButton.vue?vue&type=template&id=21336273&"
import script from "./ProjectsPanelAddProjectButton.vue?vue&type=script&lang=js&"
export * from "./ProjectsPanelAddProjectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports